<template>
  <button
    class="action-btn-component"
		:class="{ small }"
    @click.prevent="onClick"
  >
    <slot />
  </button>
</template>

<style lang="scss" src="./ActionButton.scss" />

<script>

export default {
	name: 'ActionButton',

	props: {
		action: {
			type: String,
			default: null,
		},

		small: {
			type: Boolean,
			default: false,
		},
	},

	methods: {
		onClick(event) {
			switch (this.action) {
				case 'to-action': {
					const target = document.querySelector('#action');
					target.scrollIntoView({ behavior: 'smooth' });
					break;
				}
				case 'register':
					this.$router.push('/login/registration');
					break;
				default:
					break;
			}
		},
	},
};
</script>

